<template>
	<div class="fStart bs31 bgfff">
    <div class="w200 pb20 bgFFF7F7 brF4E6E6">
      <p class="bg74ACF7 pl15 cfff hl46 f14">分类</p>

      <div
        v-for="(type, index) in typeData"
        class="helpType"
        :class="[type.id == listRequestData.typeId ? 'active' : '']"
        @click="typeChoose(type.id)"
        >
        <p>{{type.helpInfoTypeName}}</p>
      </div>
    </div>

    <div class="f1 pt14 pl20 pr41 pb34">
      <p class="fSpace f14 mb16">
        <span class="c666">列表</span>
        <span class="cp c4772FF btnhc4772FF" @click="handleCustomerBtn()">未找到相关问题？客服在线帮助</span>
      </p>

      <div class="demo-spin-col mh150 pr">
        <Spin fix v-show="listLoding">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>

        <ul v-if="listData.length > 0">
          <li class="bbE5E5E5" v-for="(list,index) in listData">
            <router-link :to="'/Help/Detail/' + list.id" class="h80 df jcc fDC db">
              <p class="f16 hl20 c333 mb15">{{list.title}}</p>

              <div class="fSpace c999 hl20">
                <p>{{list.createTime ? list.createTime.split(' ')[0] : ''}}</p>
                <p class="w80">
                  <Icon color="#999" size=14 type="md-eye" />
                  {{list.viewCount}}
                </p>
              </div>
            </router-link>
          </li>

          <li class="hl40 tc" v-show="isMore"><span class="c0077DA btnh0077DA cp" @click="getMore">加载更多</span></li>
        </ul>

        <div v-else>
            <div class="w100b h360 fDColumn aic jcc tc">
              <span class="db wh80 tip_prompt"></span>
              <p class="fb f19 mt15">暂无内容</p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '@/store/store';

  let _this = '';
  export default{
    store, // 引用

    data(){
      return {
        listLoding: true,
        typeData:[],  // 分类
        isMore: false,

        listRequestData:{
          page: 1,
          rows: 8,
          status: '10',
          typeId: ''
        },

        listData:[],  // 列表
      }  
    },
    methods:{
      // 获取分类
      getType(){
        this.sendOther({
          url: '/web/independent/help/findHelpTypeAll',
        }, (result)=>{
          // console.log("ack回调", result.data);
          this.typeData = result.data.data;

          this.listRequestData.typeId = this.typeData[0].id;

          this.getList();  // 获取列表
        }, (result)=>{
          // console.log("其他回调", result);
        })
      },

      // 获取列表
      getList(){
        this.listLoding = true;
        this.isMore = false;

        this.sendOther({
          url: '/web/independent/help/page',
          data: this.listRequestData
        }, (result)=>{
          // console.log("ack回调", result.data);
          this.listData = this.listData.concat(result.data.data);
          this.listLoding = false;
          this.isMore = result.data.data.length == this.listRequestData.rows ? true : false;
        }, (result)=>{
          // console.log("其他回调", result);
        })
      },

      // 加载更多
      getMore(){
        this.listRequestData.page += 1;
        this.getList();
      },

      // 选择分类
      typeChoose(id){
        this.listRequestData.page = 1;
        this.listRequestData.typeId = id;
        this.listData = [];
        this.getList();  // 获取列表
      }
    },
    created(){
      _this = this;
      this.getType();  // 获取分类
    },
    mounted(){
    }
  }
</script>

<style>
  ul,li{
    list-style: none;
  }
  
  /*分类选中样式*/
    .helpType{
      padding-left: 15px;
      height: 52px;
      line-height: 52px;
      cursor: pointer;
      border-bottom: 1px solid #F4E6E6;
      font-size: 14px;
    }
    .helpType.active{
      margin-top: -1px;
      border-top: 1px solid #FFF7F7;
      border-bottom: none;
      font-size: 16px;
    }
    .helpType.active p{
      padding-left: 15px;
      font-weight: 700;
      color: #E1241A;
      background-color: #fff;
      margin-right: -1px;
      border: 1px solid #F4E6E6;
      border-right: 1px solid #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/help/HelpIndex.vue